export enum TypeOfPerson {
  NATURAL = 'F', // Pessoa Física
  LEGAL = 'J' // Pessoa Juridica
}
